import { useCommonContext } from "@/utils/context/common";
import { ProductDetailModel } from "@akc/biz-api";
import { useSearchParams } from "react-router-dom";
/**
 * 商品详情埋点钩子
 * @param pageName
 * @returns
 */
export const useTrack = (pageName?: string, productDetail?: ProductDetailModel) => {
  const { track } = useCommonContext();
  const [search] = useSearchParams();
  // PV
  const trackPageView = (params?: {
    previousPageName?: string | null;
    merchantShopCode?: string | null;
    activitySpuCode?: string | null;
    skuId?: string | null;
    spuId?: string | null;
    productModel?: string | null;
    activityId?: string | null;
    liveNo?: string | null;
    liveTitle?: string | null;
  }) => {
    try {
      if (track.track) {
        track.track("$pageview", {
          page_name: pageName,
          previous_page_name: params?.previousPageName,
          merchant_shop_code: params?.merchantShopCode,
          activity_spu_code: params?.activitySpuCode,
          sku_id: params?.skuId,
          spu_id: params?.spuId,
          product_model: params?.productModel,
          activity_id: params?.activityId,
          live_no: params?.liveNo,
          live_name: params?.liveTitle,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  // 送给朋友
  const trackGiveFriend = () => {
    if (track.track) {
      track.track("btn_click", {
        page_name: pageName,
        btn_name: "送给朋友",
      });
    }
  };

  // 实拍专区埋点
  const trackReplacePoint = (btn_name: string, material_id?: string) => {
    if (track.track) {
      track.track("resource_click", {
        page_name: "商品详情页",
        domain: "商品详情",
        resource_type: "素材",
        btn_name,
        material_id,
      });
    }
  };

  // 跳转直播间埋点
  const enterLiveTrack = trackOpts => {
    track.track?.("live_entrance_click", {
      ...(trackOpts || {}),
      page_name: pageName,
      previous_page_name: search.get("previous_page_name") ?? search.get("page_name") ?? pageName,
      merchant_shop_code: productDetail?.activitySimpleVO?.merchantShopCode,
      activity_id: productDetail?.activityId,
      activity_spu_id: productDetail?.activitySpuId,
    });
  };

  return {
    trackPageView,
    trackGiveFriend,
    trackReplacePoint,
    enterLiveTrack,
  };
};
